import { creditPolicyResponse } from '@atlassian/cssxp-types-billing';
import { createAxiosClient, ServiceProxyMap } from '@atlassian/temp-client-utils';

const client = createAxiosClient({ baseURL: '/api/1/cms' }, ServiceProxyMap.ANS);

export const partnerFinancePolicyCheck = async (requestPayload: {
  id: string;
  transactionAccountId: string;
}): Promise<creditPolicyResponse> => {
  const response = await client.post('/financeCheck', requestPayload);
  return response.data;
};
